type TrainIconProps = {
  size?: number;
  color?: string;
  className?: string;
  x?: number;
  y?: number;
};

export default function TrainIcon({
  size = 120,
  color = "#F2C300",
  className,
  x = 0,
  y = -36,
}: TrainIconProps) {
  return (
    <svg
      x={x}
      y={y}
      width="54"
      height={size}
      viewBox="0 0 54 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" width="21" height="2" rx="1" fill={color} />
      <path
        d="M40.48 1H3.52C1.57596 1 0 2.79086 0 5V19C0 21.2091 1.57596 23 3.52 23H40.48C42.424 23 44 21.2091 44 19V5C44 2.79086 42.424 1 40.48 1Z"
        fill="#D5D5D5"
      />
      <path
        d="M43.9828 1C51.9656 8 55.7469 23 53.226 23H36V1H43.9828Z"
        fill={color}
      />
      <path
        d="M42.7964 1C48.2389 7.66667 55.4501 23 50.1437 23H33V1H42.7964Z"
        fill="#1B1E22"
      />
      <path
        d="M42 3H36C34.8954 3 34 3.89543 34 5V11C34 12.1046 34.8954 13 36 13H42C43.1046 13 44 12.1046 44 11V5C44 3.89543 43.1046 3 42 3Z"
        fill="#B0BEC5"
      />
      <path d="M44 3H34V6H44V3Z" fill="#2C2F33" />
      <path
        d="M36 21C37.1046 21 38 20.1046 38 19C38 17.8954 37.1046 17 36 17C34.8954 17 34 17.8954 34 19C34 20.1046 34.8954 21 36 21Z"
        fill="#B0BEC5"
      />
      <path
        d="M43 21C44.1046 21 45 20.1046 45 19C45 17.8954 44.1046 17 43 17C41.8954 17 41 17.8954 41 19C41 20.1046 41.8954 21 43 21Z"
        fill="#B0BEC5"
      />
      <path
        d="M21.5 28C22.8807 28 24 26.8807 24 25.5C24 24.1193 22.8807 23 21.5 23C20.1193 23 19 24.1193 19 25.5C19 26.8807 20.1193 28 21.5 28Z"
        fill="#333333"
      />
      <path
        d="M26.5 28C27.8807 28 29 26.8807 29 25.5C29 24.1193 27.8807 23 26.5 23C25.1193 23 24 24.1193 24 25.5C24 26.8807 25.1193 28 26.5 28Z"
        fill="#333333"
      />
      <path
        d="M37.5 28C38.8807 28 40 26.8807 40 25.5C40 24.1193 38.8807 23 37.5 23C36.1193 23 35 24.1193 35 25.5C35 26.8807 36.1193 28 37.5 28Z"
        fill="#333333"
      />
      <path
        d="M42.5 28C43.8807 28 45 26.8807 45 25.5C45 24.1193 43.8807 23 42.5 23C41.1193 23 40 24.1193 40 25.5C40 26.8807 41.1193 28 42.5 28Z"
        fill="#333333"
      />
      <path
        d="M6.5 28C7.88071 28 9 26.8807 9 25.5C9 24.1193 7.88071 23 6.5 23C5.11929 23 4 24.1193 4 25.5C4 26.8807 5.11929 28 6.5 28Z"
        fill="#333333"
      />
      <path
        d="M11.5 28C12.8807 28 14 26.8807 14 25.5C14 24.1193 12.8807 23 11.5 23C10.1193 23 9 24.1193 9 25.5C9 26.8807 10.1193 28 11.5 28Z"
        fill="#333333"
      />
      <path d="M33 1H44.0769L45 2H33V1Z" fill={color} />
      <path d="M33 14H0V17H33V14Z" fill={color} />
      <path
        d="M30 2H19C18.4477 2 18 2.44771 18 3V20C18 20.5523 18.4477 21 19 21H30C30.5523 21 31 20.5523 31 20V3C31 2.44772 30.5523 2 30 2Z"
        fill="#B0BEC5"
      />
      <rect x="19" y="3.05554" width="11" height="16.8889" fill="#D5D5D5" />
      <path
        d="M23.4286 5.16666H20.5714C20.2558 5.16666 20 5.61437 20 6.16666V12.1667C20 12.7189 20.2558 13.1667 20.5714 13.1667H23.4286C23.7442 13.1667 24 12.7189 24 12.1667V6.16666C24 5.61437 23.7442 5.16666 23.4286 5.16666Z"
        fill="#B0BEC5"
      />
      <path
        d="M28.4286 5.16666H25.5714C25.2558 5.16666 25 5.61437 25 6.16666V12.1667C25 12.7189 25.2558 13.1667 25.5714 13.1667H28.4286C28.7442 13.1667 29 12.7189 29 12.1667V6.16666C29 5.61437 28.7442 5.16666 28.4286 5.16666Z"
        fill="#B0BEC5"
      />
      <path
        d="M15 2H4C3.44772 2 3 2.44771 3 3V20C3 20.5523 3.44772 21 4 21H15C15.5523 21 16 20.5523 16 20V3C16 2.44772 15.5523 2 15 2Z"
        fill="#B0BEC5"
      />
      <rect x="4" y="3.05554" width="11" height="16.8889" fill="#D5D5D5" />
      <path
        d="M8.42857 5.16666H5.57143C5.25584 5.16666 5 5.61437 5 6.16666V12.1667C5 12.7189 5.25584 13.1667 5.57143 13.1667H8.42857C8.74416 13.1667 9 12.7189 9 12.1667V6.16666C9 5.61437 8.74416 5.16666 8.42857 5.16666Z"
        fill="#B0BEC5"
      />
      <path
        d="M13.4286 5.16666H10.5714C10.2558 5.16666 10 5.61437 10 6.16666V12.1667C10 12.7189 10.2558 13.1667 10.5714 13.1667H13.4286C13.7442 13.1667 14 12.7189 14 12.1667V6.16666C14 5.61437 13.7442 5.16666 13.4286 5.16666Z"
        fill="#B0BEC5"
      />
    </svg>
  );
}
